import styled from 'styled-components';
import { Colors } from '../../constants/StyleConstants';

export const StContactContainer = styled.div`
  margin: 48px 60px 50px 50px;
`;

export const StInfosContainer = styled.div`
  color: #6e777a;
`;

export const StContactTitle = styled.p`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 4px;
`;

export const StContactText = styled.p`
  font-size: 14px;
  margin-bottom: 0;
`;

export const StyledIcon = styled.i`
  width: 30px;
  color: ${Colors.RED};
  margin: 8px 0;
`;

export const StLink = styled.a`
  font-weight: 500;
`;
